<template lang="html">
  <div>
    <example></example>
  </div>
</template>

<script>
import { Example } from '../components/'

export default {
  data: function () {
    return {
    }
  },
  computed: {},
  ready: function () {},
  attached: function () {},
  methods: {},
  components: {
    Example
  }
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** Example.vue?dcf540f8
 **/